import { createContext, useContext, useMemo, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export const ThemeContext = createContext(undefined);
export const useThemeContext = () => useContext(ThemeContext);
export const MyThemeProvider = ({ children }) => {
  const [mode, setMode] = useState("light");
  const toggleTheme = () =>
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: { main: mode === "light" ? "#475f78" : "#abc0d5" },
          background: {
            default: mode === "light" ? "#ffffff" : "#191b1f",
            paper: mode === "light" ? "#ffffff" : "#202328",
          },
          text: {
            primary: mode === "light" ? "#252a30" : "#e5e7eb",
            secondary: mode === "light" ? "#68717b" : "#a5adb8",
          },
        },
        typography: {
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif',
        },
        shape: { borderRadius: 6 },
      }),
    [mode],
  );
  return (
    <ThemeContext.Provider value={{ toggleTheme }}>
      <ThemeProvider theme={theme}>
        <div className="site-theme" data-theme={mode}>
          {children}
        </div>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
